import React from "react";
import { FormGroup, Label, Input } from "reactstrap";

const AmountStatusFilter = ({ amountStatus, onAmountStatusChange }) => {
  const amountStatusOptions = [
    { value: "", label: "All Amount Status" },
    { value: "PARTIALLY_PENDING", label: "Partially Pending" },
    { value: "PAID", label: "Paid" },
    { value: "ADVANCE_PAID", label: "Advance Paid" },
    { value: "CANCELLED", label: "Cancelled" },
  ];

  const getStatusBadgeColor = (status) => {
    switch (status) {
      case "PARTIALLY_PENDING":
        return "warning";
      case "PAID":
        return "success";
      case "ADVANCE_PAID":
        return "info";
      case "CANCELLED":
        return "danger";
      default:
        return "secondary";
    }
  };

  return (
    <div className="amount-status-filter">
      <FormGroup>
        <Label for="amountStatusFilter">Filter by Amount Status</Label>
        <Input
          type="select"
          id="amountStatusFilter"
          value={amountStatus}
          onChange={(e) => onAmountStatusChange(e.target.value)}
          className="form-control"
        >
          {amountStatusOptions.map((option) => (
            <option key={option.value} value={option.value}>
              {option.label}
            </option>
          ))}
        </Input>
      </FormGroup>
    </div>
  );
};

export default AmountStatusFilter;
